import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'

import Pattern from '../components/Pattern/Pattern.js';
import TextEditor from '../components/TextEditor/TextEditor.js'
import FormEditor from '../components/FormEditor/FormEditor.js'
import JustDrawIt from '../components/JustDrawIt/JustDrawIt.js'
import CalculatorEditor from '../components/CalculatorEditor/CalculatorEditor.js'

import { showTooltip, hideTooltip } from '../actions/actions.export.js';


var pf_config = require('../pf_config.json');

class FeatureTable extends Component {
  constructor(props){
    super(props);
  }

  render(){
    const { dispatch, user, patternManager } = this.props;

    return <div className="landing">
      <div className="screen-height-container bg-gradient">
        <div className="shc-background translucent">
          <img src="/img/herring-bone.png" width="100%"/>
        </div>
        <div className="shc-content theme-light">
          <Header transparent={true}/>
          <div className="container">
            <div className="row row-mega-padded">
              <div className="col-md-12">
                <h1 className="text-center">Features & More</h1>
                <p className="text-center lead">
                  The best .pat file editor you'll ever use.
                </p>
              </div>
            </div>
            
            <div className="row row-eq-height row-push-down-extra">
              <div className="col-md-8">
                <div className="col-themed col-themed-no-pad col-themed-fill col-themed-shadow">
                  <div className="corner-ribbon corner-ribbon-top-right">
                    Edit Me!
                  </div>
                  <TextEditor demo={true} cacheID={"features_text"}/>
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-themed col-themed-no-pad col-themed-fill col-themed-shadow col-themed-square">
                  <div className="pattern-square-wrapper">
                    <Pattern 
                      cacheID={"features_text"}
                      pattern={patternManager.cache["features_text"]}
                    />
                 </div>
                </div>
              </div>
            </div>



            <div className="row row-eq-height row-push-down-extra">
              <div className="col-md-8">
                <div className="col-themed col-themed-no-pad col-themed-fill col-themed-shadow">
                  <div className="corner-ribbon corner-ribbon-top-right">
                    Edit Me!
                  </div>
                  <FormEditor cacheID={"features_text"}/>
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-themed col-themed-no-pad col-themed-fill col-themed-shadow col-themed-square">
                  <div className="pattern-square-wrapper">
                    <Pattern 
                      cacheID={"features_text"}
                      pattern={patternManager.cache["features_text"]}
                    />
                 </div>
                </div>
              </div>
            </div>


            <div className="row row-eq-height row-push-down-extra">
              <div className="col-md-4">
                <div className="col-themed col-themed-no-pad col-themed-fill col-themed-shadow">
                  <div className="corner-ribbon corner-ribbon-top-right">
                    Edit Me!
                  </div>
                  <JustDrawIt 
                    demo={true}
                    tool={"Pen"}
                    cacheID={"features_text"}
                    pattern={patternManager.cache["features_text"]}
                    />
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-themed col-themed-no-pad col-themed-fill col-themed-shadow col-themed-square">
                  <div className="pattern-square-wrapper">
                    <Pattern 
                      cacheID={"features_text"}
                      pattern={patternManager.cache["features_text"]}
                    />
                 </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="col-themed col-themed-no-pad col-themed-fill col-themed-shadow col-themed-square">
                  <div className="pattern-square-wrapper">
                    <TextEditor 
                      cacheID={"features_text"}
                      
                    />
                 </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div className="section-breaker">
        <div className="container">
            <div className="row justify-content-center">
            <div className="col-md-4 text-center">
              <div className="flex-center-column">
                <h2>Try it first!</h2>
                <p>A few minutes and you'll see why those ancient plug-ins aren't worth it.</p>
                <Link to="/new/drawing" className="button-link">
                  <Button
                    display={<span>Try Pattycake for Free&nbsp; <i className="fal fa-angle-right"/></span>}
                    color="primary"
                    size="medium"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-breaker section-breaker-secondary">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="flex-center-column">
                <h3>Still not sure?</h3>
                <p className="text-center">
                  We've broken out every individual feature for you so you can make decisions with confidence. 
                </p>
                <br/>
                <Link to="/feature-table" className="button-link">
                  <Button
                    display={<span>Compare plans in detail&nbsp; <i className="fal fa-angle-right"/></span>}
                    color="white"
                    size="medium"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user, patternManager } = state;

  return {
    user, patternManager
  }
}

export default connect(mapStateToProps)(FeatureTable);



// WEBPACK FOOTER //
// ./src/routes/Features.js